module.exports = __webpack_public_path__ + "static/media/ic_Contactus.b044df41.svg";